export const TEST_ID = 'searchInput';

export const CLEAR_BUTTON_TEST_ID = 'searchInputClearButton';

export const DEFAULT_PLACEHOLDER = 'Search address, airport, or place';

export const CLEAR_LABEL = 'Clear search';

// Magnifier SVG — 18×18 viewBox, 1.8px stroke; matches FAA drawer v2 prototype.
export const MAGNIFIER_SIZE = 18;

export const MAGNIFIER_CIRCLE_CX = 8;

export const MAGNIFIER_CIRCLE_CY = 8;

export const MAGNIFIER_CIRCLE_R = 5.5;

export const MAGNIFIER_HANDLE_X1 = 12.2;

export const MAGNIFIER_HANDLE_Y1 = 12.2;

export const MAGNIFIER_HANDLE_X2 = 16;

export const MAGNIFIER_HANDLE_Y2 = 16;

export const MAGNIFIER_STROKE_WIDTH = 1.8;

// Clear-pill "x" SVG — 10×10 viewBox, 1.5px stroke, drawn corner-to-corner.
export const CLEAR_ICON_SIZE = 10;

export const CLEAR_ICON_START = 2;

export const CLEAR_ICON_END = 8;

export const CLEAR_ICON_STROKE_WIDTH = 1.5;
